import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RolePipe } from 'src/app/pipe/role.pipe';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { UtilService } from 'src/app/service/util.service';
import { ToastService } from 'src/app/service/toast.service';
import { Constants } from 'src/app/constants/constants';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss']
})
export class CustomerDetailComponent implements OnInit {

  customer: any = null;
  customerRoles: any;
  status: Array<string> = ["INACTIVE", "PENDING", "ACTIVE", "DISABLED"];
  customerStatus: string = this.status[2];
  customerList: any = [];
  accountCategory: string;
  loggedInUserId: any;
  @ViewChild('updateRoleForm') public updateRoleForm: NgForm;
  updateRoleModal = null;
  rolePipe: RolePipe = new RolePipe();
  authSubscription: any;
  isSelfAccount = false;
  selectedDrivers: Array<string> = new Array();
  
  constructor(private route: ActivatedRoute, private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.customer = this.utilService.selectedAccountUser;
    this.customerStatus = (this.customer && this.customer.status) ? this.customer.status : this.status[2];
    console.log("customer :: ", this.customer, " -- logged in user : ", this.authService.loggedInUser);
    this.loggedInUserId = this.authService.loggedInUser.userId;

  }


  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  onDriverSelected(id: string) {
    console.log("Driver id::", id);
    let itemIndex = this.selectedDrivers.indexOf(id);
    if (itemIndex !== -1) {
      this.selectedDrivers.splice(itemIndex, 1);
    } else {
      this.selectedDrivers.push(id);
    }
    console.log("selected drivers::", this.selectedDrivers);
  }


  currentConfirmation = {
    heading: null,
    content: null
  }

  onUserDeactivate() {
    this.currentConfirmation.heading = "Deactivate User";
    this.currentConfirmation.content = "Confirm deactivating " + this.customer.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  onUserActivate() {
    console.log("Activating user : ", this.customer.id);
    // this.activateUser(this.customer.id);
  }

  onResetPassword() {
    this.currentConfirmation.heading = "Reset Password";
    this.currentConfirmation.content = "Confirm reset password for " + this.customer.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  onInviteResend() {
    this.currentConfirmation.heading = "Resend Invite";
    this.currentConfirmation.content = "Confirm resend invite to for " + this.customer.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  confirm() {

    if (this.currentConfirmation.heading == "Deactivate User") {
      // Handle user deactivate
      console.log("Deactivating user : ", this.customer.id);
      // this.deactivateUser(this.customer.id);
    } else if (this.currentConfirmation.heading == "Reset Password") {
      // Handle user password reset
      console.log("Reset user : ", this.customer.username);
      // this.resetUserPassword(this.customer.username);
    } else if (this.currentConfirmation.heading == "Resend Invite") {
      // document.getElementById("closeConfirmationModel").click();
      // this.resendInvite(this.customer.id);
    }

  }

  deactivateUser(userId) {
    this.utilService.showSpinner();
    this.apiService.deactivateAccountUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess("User deactivated successfully");
      this.customerStatus = this.status[3];
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deactivateUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  activateUser(userId) {
    this.utilService.showSpinner();
    this.apiService.activateAccountUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.customerStatus = this.status[2];
      this.toast.showSuccess("User activated successfully");
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.activateUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetUserPassword(username) {
    var resetPasswordRequest = {
      "username": username
    };

    this.utilService.showSpinner();
    this.authService.forgotPassword(resetPasswordRequest).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data['message']);
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.resetUserPassword(username);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resendInvite(userId) {
    this.utilService.showSpinner();
    this.apiService.resendUserInvite(userId).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data.message);
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.activateUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onTwoStepVerificationCheckboxClick() {
    return false;
  }

}
